import { useFreeCropInteraction } from './useFreeCropInteraction';
import { useFreeCropRender } from './useFreeCropRender';

type UseFreeCropLogicParams = {
  imageUrl: string;
  file: File;
  onChange?: (state: { loading?: boolean }) => void;
};

export const useFreeCropLogic = ({ imageUrl, file, onChange }: UseFreeCropLogicParams) => {
  const {
    containerRef,
    previewCanvasRef,
    loading,
    naturalSize,
    corners,
    setCorners,
    showPreview,
    preview,
    done,
    reset,
    showPreviewAction,
    hidePreviewAction,
    saveChanges,
    revertToInitial,
    getSavedImage,
    drawPreview,
    getCornerAtPoint,
    getEdgeAtPoint,
    clampCorner,
  } = useFreeCropRender({ imageUrl, file, onChange });

  const { isDragging, handlePointerDown, handlePointerMove, handlePointerUp, handlePointerLeave } =
    useFreeCropInteraction({
      previewCanvasRef,
      naturalSize,
      showPreview,
      getCornerAtPoint,
      getEdgeAtPoint,
      clampCorner,
      setCorners,
      drawPreview,
    });

  return {
    containerRef,
    previewCanvasRef,
    loading,
    showPreview,
    isDragging,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    handlePointerLeave,
    preview,
    done,
    reset,
    showPreviewAction,
    hidePreviewAction,
    saveChanges,
    revertToInitial,
    getSavedImage,
    corners,
  };
};
